var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","xl":"10"}},[_c('v-text-field',_vm._b({model:{value:(_vm.weaponProperty),callback:function ($$v) {_vm.weaponProperty=$$v},expression:"weaponProperty"}},'v-text-field',_vm.$attrs,false))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }